import { i18n } from "@/boot/i18n";

export const ACCESS_REQUEST_STATUS = {
  0: i18n.t("consts.access_request.pending"),
  1: i18n.t("consts.access_request.approved"),
  2: i18n.t("consts.access_request.rejected")
};
